// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11xas","newExpiryDate":"styles_newExpiryDate__1EMTH","footer":"styles_footer__sBV7Z"};